module.exports = __webpack_public_path__ + "img/9788990462428.3a9363ca.jpg";